module.exports = __webpack_public_path__ + "static/thumbnail_01_sprite.baa17ff4.png";